<template>
 <div class="holiday-calendar">
    <el-calendar v-model="currentValue">
      <template
      slot="dateCell"
      slot-scope="{date, data}">
      <p v-if="getHolidayType(data.day) && isHoliday(data.day)" class="is-selected">
        {{ Number(data.day.split('-')[2]) }}
        <i class="el-icon-check"></i>
        <br/>
        <span>{{getHolidayType(data.day)}}</span>
      </p>
      <p v-else>
        {{ Number(data.day.split('-')[2])  }}
        <span>{{getHolidayType(data.day)}}</span>
      </p>
    </template>
    </el-calendar>
 </div>
</template>

<script>
import { formatZero } from '@/utils/formUtils'
import { formatHolidayType } from '@/utils/enumeration/lab-order'
export default {
  props: {
    value: {
      type: [Date, String, Number],
      default: new Date()
    },
    holidays: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentHolidays: this.holidays ? this.formatHoliday(this.holidays) : [],
      currentValue: this.value ? this.value : new Date()
    }
  },
  watch: {
    value (val) {
      val && (this.currentValue = val)
    },
    holidays (val) {
      this.currentHolidays = val ? this.formatHoliday(val) : []
    }
  },
  methods: {
    formatHolidayType,
    formatHoliday (datas) {
      return datas.map(e => {
        return {
          ...e,
          date: [e.year, formatZero(e.month, 2), formatZero(e.day, 2)].join('-')
        }
      })
    },
    isHoliday (day) {
      let res = this.currentHolidays.filter(e => e.date === day)
      let type = res && res[0] ? res[0].holidayType : ''
      if (type && type === 'MAKE_UP_FOR_WORK') {
        return false
      }
      return true
    },
    getHolidayType (day) {
      let res = this.currentHolidays.filter(e => e.date === day)
      return res && res[0] ? res[0].name : ''
    }
  }
}
</script>

<style lang="less">
.holiday-calendar{
  .el-button-group{
    display: none;
  }
  .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev{
pointer-events: none;
}
  .el-calendar-day{
    padding: 0;
  }
  .el-calendar-day >p{
    padding: 0.08rem;
    margin: 0;
    height: 100%;
    box-sizing: border-box;
    &.is-selected{
      background: #f2f8fe;
      i{
         color: #1989fa;
         font-size: 18px;
         font-weight: bold;
      }
      span{
        color:#3e3e3e;
      }
    }
  }
}
</style>
